(ns builder.index.model
  (:require [re-frame.core :as rf]
            [zf.form]
            #?(:cljs [zframes.xhr])
            [clojure.string :as str]
            [builder.sdc.browser]
            [builder.sdc.posthog :as posthog]
            #?(:cljs ["lz-string" :refer [compressToEncodedURIComponent]])
            #?(:cljs [zframes.debounce])
            #?(:cljs [goog.crypt.base64 :as b64])
            #?(:cljs [goog.crypt :as crypt])
            #?(:cljs [goog.crypt.Sha256 :as sha256])
            #?(:cljs [zframes.redirect])
            #?(:cljs [zframes.storage])
            #?(:cljs [zframes.routing])
            #?(:cljs [goog.string :as gstring])
            [zframes.cookies]))

#?(:cljs (goog-define PORTAL_BASE_URL "http://127.0.0.1.nip.io:8789")
   :clj (def PORTAL_BASE_URL "http://localhost:8789"))
#?(:cljs (goog-define AUTH_REDIRECT_URL "http://localhost:8765/")
   :clj (def AUTH_REDIRECT_URL "http://localhost:8765/"))

(def marketing-click-id-keys
  #{:gclid
    :fbclid
    :msclkid
    :ttclid
    :twclid})

(defn marketing-attribution [params]
  (reduce-kv (fn [acc k v]
               (if (or (str/starts-with? (name k) "utm_")
                       (contains? marketing-click-id-keys k))
                 (assoc acc k v)
                 acc))
             {}
             params))

(defn portal-auth-params [code-verifier attribution]
  (merge {:response_type "code"
          :client_id "public-builder-client"
          :code_challenge (sha256-hash-base64-urlsafe code-verifier)
          :code_challenge_method "S256"
          :redirect_uri AUTH_REDIRECT_URL}
         attribution))

(rf/reg-event-fx
 ::start-from-scratch
 (fn [{db :db} _]
   {:route-map/redirect "/builder"}))

(rf/reg-event-fx
 ::create-from-scratch-with-auth
 [(rf/inject-cofx :zframes.cookies/get :aidbox-token)]
 (fn [{db :db {aidbox-token :aidbox-token} :cookie} _]
   (if aidbox-token
     {:dispatch [::start-from-scratch]}
     {:dispatch [::trigger-authorization "builder"]})))

(rf/reg-event-fx
 ::show-form-import-with-auth
 [(rf/inject-cofx :zframes.cookies/get :aidbox-token)]
 (fn [{db :db {aidbox-token :aidbox-token} :cookie} _]
   (if aidbox-token
     {:dispatch [::show-form-import]}
     {:dispatch [::trigger-authorization "index"]})))

(rf/reg-event-fx
 ::open-questionnaire-with-auth
 [(rf/inject-cofx :zframes.cookies/get :aidbox-token)]
 (fn [{db :db {aidbox-token :aidbox-token} :cookie} [_ q]]
   (if aidbox-token
     {:dispatch [::open-questionnaire q]}
     {:storage/set {:pending-questionnaire q
                    :authorize-from "open-questionnaire"}
      :dispatch [::trigger-authorization "open-questionnaire"]})))

(rf/reg-event-fx
 ::load-file-ok
 (fn [{db :db} [_ text-q]]
   (let [json-q #?(:cljs (-> (js/JSON.parse text-q)
                             (js->clj :keywordize-keys true))
                   :clj {})]

     {:dispatch [::open-questionnaire json-q]})))

(rf/reg-event-fx
 ::open-questionnaire
 (fn [{db :db} [_ q]]
   {:route-map/redirect (str "/builder/" (:id q))}))

(rf/reg-event-fx
 ::load-file
 (fn [{db :db} [_ e]]
   (let [file (first (.. e -target -files))
         reader #?(:cljs (new js/FileReader)
                   :clj nil)]
     (.addEventListener reader "load" #(rf/dispatch [::load-file-ok (.. % -target -result)]))
     (.readAsText reader file))))

(rf/reg-event-fx
 ::toggle-details
 (fn [{db :db} [_ id]]
   (let [details (zf.form/state db {:zf/root [::db] :zf/path [:selected-questionnaire]})
         new-details (if (not= details id) id nil)]
     {:db (zf.form/set-state db {:zf/root [::db] :zf/path [:selected-questionnaire]} new-details)})))

(rf/reg-sub
 ::selected-questionnaire
 (fn [db _]
   (zf.form/state db {:zf/root [::db] :zf/path [:selected-questionnaire]})))

(rf/reg-event-fx
 ::load-questionnaires
 (fn [{db :db} [_ _]]
   (let [page (get-in db [:fragment-params :params :page])
         query (get-in db [:fragment-params :params :query])
         filters (zf.form/state db {:zf/root [::db] :zf/path [:filters]})]

     {:json/fetch {:uri "/Questionnaire"
                   :method :GET
                   :params (cond-> {:_count 50
                                    :_sort "publisher"}
                             page (assoc :page page)
                             query (assoc "title:contains" query)
                             (:openehr-templates filters) (assoc ".extension$contains" "openehr-template-source"))
                   :path [::db :questionnaires]}})))

(rf/reg-event-fx
 ::search-changed
 (fn [{db :db} [_ query]]
   {:route-map/set-params {:query query
                           :page 1}}))

(rf/reg-event-fx
 ::toggle-form-filter
 (fn [{db :db} [_ form-filter]]
   (let [state (zf.form/state db {:zf/root [::db] :zf/path [:filters]} [form-filter])]
     {:db (zf.form/set-state db {:zf/root [::db] :zf/path [:filters]} [form-filter] (not state))
      :dispatch [::load-questionnaires]})))

(rf/reg-sub
 ::filter-enabled?
 :<- [:zf/state {:zf/root [::db] :zf/path [:filters]}]
 (fn [state [_ form-filter]]
   (get state form-filter)))

(rf/reg-sub
 ::is-authenticated?
 :<- [:zf/value {:zf/root [::db] :zf/path [:aidbox-token]}]
 (fn [token _]
   (boolean token)))

(rf/reg-sub
 ::userinfo
 :<- [:zf/value {:zf/root [::db] :zf/path [:userinfo]}]
 (fn [userinfo _]
   userinfo))

(defn get-page [data kind]
  (when-let [relation (some->> data
                               :data
                               :link
                               (filter #(= (:relation %) kind))
                               first
                               :url)]
    (->> relation
         (re-find #"page=([0-9]+)")
         second)))

(rf/reg-sub
 ::form-preview-id
 (fn [db _]
   (zf.form/value db {:zf/root [::db] :zf/path [:preview :form-id]})))

(rf/reg-event-fx
 ::show-preview
 (fn [{db :db} [_ {:keys [id title]}]]
   {:db (zf.form/*set-value db {:zf/root [::db] :zf/path [:preview :form-id]} id)
    :dispatch-n [[:toolkit.modal/show-modal :form-preview]
                 [::posthog/report-event {:event "box_sdc:public_builder:preview-form"
                                         :properties {:title title}}]]}))

(defn code-verifier
  []
  (let [length (+ 43 (rand-int 85)) ;; length should be between 43 and 128
        charset "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"]
    (apply str (take length (repeatedly #(nth charset (rand-int (count charset))))))))

(defn sha256-hash-base64-urlsafe
  "Compute the SHA256 hash of a given string and return it as a base64 URL-safe encoded string"
  [s]
  #?(:cljs (let [sha256 (goog.crypt.Sha256.)
                 s-bytes (goog.crypt/stringToUtf8ByteArray s)]
             (.update sha256 s-bytes)
             (-> (.digest sha256)
                 (goog.crypt.base64/encodeByteArray goog.crypt.base64.Alphabet.WEBSAFE_NO_PADDING)))
     :clj nil))

(rf/reg-event-fx
 ::do-authorization
 [(rf/inject-cofx :storage/get [:authorize-from :marketing-attribution])]
 (fn [{db :db {authorize-from :authorize-from
               stored-attribution :marketing-attribution} :storage} [_]]
   (let [cv (code-verifier)
         source (or authorize-from "index")
         current-attribution (marketing-attribution (:location/search db))
         attribution (merge stored-attribution current-attribution)]
     {:zframes.redirect/page-redirect {:uri #?(:cljs (gstring/format "%s/ui/portal" PORTAL_BASE_URL)
                                               :clj (format "%s/ui/portal" PORTAL_BASE_URL))
                                       :params (portal-auth-params cv attribution)}
      :storage/set (cond-> {:code-verifier cv
                            :authorize-from source}
                     (seq attribution)
                     (assoc :marketing-attribution attribution))
      :dispatch [:toolkit.modal/hide-modal]})))

(rf/reg-event-fx
 ::trigger-authorization
 (fn [{db :db} [_ source]]
   {:dispatch [:toolkit.modal/show-modal :auth-sign-in]
    :storage/set {:authorize-from (or source "index")}}))

(rf/reg-event-fx
 ::handle-message
 [(rf/inject-cofx :storage/get [:marketing-attribution])]
 (fn [{db :db {stored-attribution :marketing-attribution} :storage} [_ message]]
   (let [code-verifier (code-verifier)
         current-attribution (marketing-attribution (:location/search db))
         attribution (merge stored-attribution current-attribution)]
     (cond (= (:messageType message) "from-aidbox-forms/authorize")
           {:zframes.redirect/page-redirect {:uri #?(:cljs (gstring/format "%s/ui/portal" PORTAL_BASE_URL)
                                                     :clj (format "%s/ui/portal" PORTAL_BASE_URL))
                                             :params (portal-auth-params code-verifier attribution)}
            :storage/set (cond-> {:code-verifier code-verifier
                                  :authorize-from "index"}
                           (seq attribution)
                           (assoc :marketing-attribution attribution))}

           (= (:messageType message) "sdc.public-builder.got-token")
           (rf/dispatch [::navigate-back-with-token])

           (= (:messageType message) "sdc.aidbox.persistQuestionnaire")
           (let [data #?(:cljs (compressToEncodedURIComponent (js/JSON.stringify (clj->js (get-in message [:payload :questionnaire]))))
                         :clj nil)]
             {:db (assoc-in db [:questionnaire] (get-in message [:payload :questionnaire]))
              :zframes.redirect/redirect {:uri (str "/builder?q-data=" data)}})

           (= (:messageType message) "sdc.aidbox-forms.pdf-generated")
           {:dispatch [::upload-pdf-to-bucket (:payload message)]}

           (= (:messageType message) "sdc.aidbox-forms.openehr-template-converted")
           {:dispatch [::upload-template-to-bucket (:payload message)]}))))

(rf/reg-event-fx
 ::navigate-back-with-token
 [(rf/inject-cofx :storage/get [:authorize-from])
  (rf/inject-cofx :storage/get [:pending-questionnaire])]
 (fn [{db :db {authorize-from :authorize-from} :storage {pending-q :pending-questionnaire} :storage} _]
   (cond
     (= authorize-from "builder")
     {:route-map/redirect "/builder"}

     (= authorize-from "index")
     {:dispatch [:toolkit.modal/show-modal :form-import]}

     (= authorize-from "open-questionnaire")
     {:dispatch [::open-questionnaire pending-q]
      :storage/remove [:pending-questionnaire]}

     :else
     {:dispatch [:toolkit.modal/show-modal :form-import]})))

(rf/reg-event-fx
 ::get-portal-token-ok
 (fn [{db :db} [_ {{access-token :access_token :as userinfo} :data}]]
   (let [opener #?(:cljs (.-opener js/window)
                   :clj nil)
         user-email (:email userinfo)]
     (cond-> {:db (zf.form/*set-value db {:zf/root [::db] :zf/path [:userinfo]} (dissoc userinfo :access_token))
              :storage/set {:aidbox-token access-token
                            :userinfo (dissoc userinfo :access_token)}
              :zframes.cookies/set {:key "aidbox-token"
                                    :value access-token}
              :dispatch [::posthog/report-event {:event "box_sdc:public_builder:user_signed_in"
                                                :properties {:user_id user-email}}]}

       opener
       (assoc :browser/post-host-message [{:messageType "sdc.public-builder.got-token"}])

       opener
       (assoc :browser/close-window {})

       (not opener)
       (assoc :dispatch-n [[::posthog/report-event {:event "box_sdc:public_builder:user_signed_in"
                                                    :properties {:user_id user-email}}]
                           [:zf.form/set-value {:zf/root [::db] :zf/path [:aidbox-token] :value access-token}]
                           [::navigate-back-with-token]])))))

(rf/reg-event-fx
 ::get-portal-token
 [(rf/inject-cofx :storage/get [:code-verifier])]
 (fn [{db :db {code-verifier :code-verifier} :storage} [_ code]]
   {:json/fetch {:uri #?(:cljs (gstring/format "%s/auth/token" PORTAL_BASE_URL)
                         :clj (format "%s/auth/token" PORTAL_BASE_URL))
                 :method "POST"
                 :body {:grant_type "authorization_code"
                        :code code
                        :client_id "public-builder-client"
                        :code_verifier code-verifier}
                 :success {:event ::get-portal-token-ok}}
    :storage/remove [:code-verifier]}))

(rf/reg-event-fx
 ::show-form-import
 (fn [{db :db} _]
   {:dispatch [:toolkit.modal/show-modal :form-import]}))

(rf/reg-event-fx
 ::logout
 (fn [{db :db} _]
   {:storage/remove [:aidbox-token :userinfo]
    :zframes.cookies/remove "aidbox-token"
    :dispatch [::posthog/reset]
    :db (-> db
            (update ::db dissoc :aidbox-token :userinfo)
            (zf.form/*set-value {:zf/root [::db] :zf/path [:userinfo]} nil))}))

(defn base64-to-binary [base64-data-uri]
    ;; Remove the prefix (e.g., "data:image/png;base64,")
  (let [base64-data (last (clojure.string/split base64-data-uri #","))
        binary-str #?(:cljs (b64/decodeString base64-data)
                      :clj nil)
        len (count binary-str)
        ab #?(:cljs (js/ArrayBuffer. len)
              :clj nil)
        binary-array #?(:cljs (js/Uint8Array. ab)
                        :clj nil)]
    (doseq [i (range len)]
      (aset binary-array i (.charCodeAt binary-str i)))
    ab))

(rf/reg-event-fx
 ::upload-ok
 (fn [{db :db} [_ resp]]
   (prn "Upload ok response: " resp)))

(rf/reg-event-fx
 ::upload-error
 (fn [{db :db} [_ resp]]
   (prn "Upload error response: " resp)))

(rf/reg-event-fx
 ::get-signed-url-ok
 (fn [{db :db} [_ {{url :url} :data
                   file :file
                   content-type :content-type}]]
   (let [pdf? #?(:cljs (instance? js/ArrayBuffer file)
                 :clj nil)
         buffer file
         content-type (or content-type
                          (if pdf? "application/pdf" "application/json"))]
     {:json/fetch {:method "PUT"
                   :uri url
                   :headers {:content-type content-type}
                   :format :specified-in-headers
                   :body buffer
                   :success {:event ::upload-ok}
                   :error {:event ::upload-error}}})))

(rf/reg-event-fx
 ::get-signed-url
 (fn [{db :db} [_ {:keys [filename data content-type remote-name]}]]
   (let [remote-name (or remote-name
                         (if #?(:cljs (instance? js/ArrayBuffer data)
                                :clj true)
                           "source.pdf"
                           "questionnaire.json"))]
     {:json/fetch {:method "POST"
                   :uri "/gcp/storage/gcp-pdf-test-account/public-builder-pdf-forms"
                   :headers {:authorization "Basic cGRmLXN0b3JlOnBkZi1zdG9yZS1zZWNyZXQ="}
                   :body {:filename (str filename "/" remote-name)}
                   :success {:event ::get-signed-url-ok
                             :file data
                             :content-type content-type}
                   :error {:event ::get-signed-url-error}}})))

(rf/reg-event-fx
 ::upload-pdf-to-bucket
 (fn [{db :db} [_ {:keys [questionnaire file]}]]
   {:dispatch-n [[::posthog/report-event {:event "box_sdc:public_builder:pdf-generated" :properties {}}]
                 [::get-signed-url {:filename (:filename file)
                                    :data (:buffer file)}]
                 [::get-signed-url {:filename (:filename file)
                                    :data questionnaire}]]}))

(rf/reg-event-fx
 ::upload-template-to-bucket
 (fn [{db :db} [_ template-content]]
   (let [timestamp #?(:cljs (.now js/Date)
                      :clj (System/currentTimeMillis))
         filename (str "template-" timestamp)]
     {:dispatch-n [[::posthog/report-event {:event "box_sdc:public_builder:openehr-template-converted" :properties {}}]
                   [::get-signed-url {:filename filename
                                      :data template-content
                                      :content-type "application/xml"
                                      :remote-name "template.xml"}]]})))

(rf/reg-sub
 ::model
 (fn [db _]
   (let [data (get-in db [::db :questionnaires])
         questionnaires (->> data
                             :data
                             :entry
                             (map :resource))
         cnt (count questionnaires)
         next-page (get-page data "next")
         previous-page (get-page data "previous")
         current-page (get-page data "self")
         total (get-in data [:data :total])
         query (get-in db [:fragment-params :params :query])]
     {:loading? (= (:status data) "loading")
      :questionnaires questionnaires
      :next-page next-page
      :previous-page previous-page
      :query query
      :showing {:from (inc (* (dec current-page) cnt))
                :to (if (< total cnt) total
                        (* current-page cnt))
                :total total}})))

(rf/reg-event-fx
 ::ctx
 [(rf/inject-cofx :zframes.cookies/get :aidbox-token)
  (rf/inject-cofx :storage/get [:userinfo])]
 (fn [{db :db {aidbox-token :aidbox-token} :cookie {userinfo :userinfo} :storage} [_ phase params]]
   (let [code (or (get-in db [:location/search :code])
                  (get-in db [:fragment-params :params :code]))
         attribution (marketing-attribution (:location/search db))]
     (cond
       (= :init phase)
       (cond-> {:db db
                :dispatch-n [[::load-questionnaires]]
                :browser/listen-post-message [::handle-message]}
         code
         (update :dispatch-n into [[::get-portal-token code]])

         aidbox-token
         (update :dispatch-n conj [:zf.form/set-value {:zf/root [::db] :zf/path [:aidbox-token] :value aidbox-token}])

         (seq attribution)
         (assoc :storage/set {:marketing-attribution attribution})

         userinfo
         (-> (update :dispatch-n conj [:zf.form/set-value {:zf/root [::db] :zf/path [:userinfo] :value (dissoc userinfo :access_token)}])
             (update :dispatch-n conj [::posthog/identify (:userinfo userinfo)])))
       #_(if-not code
           {:dispatch-n [[::load-questionnaires]]
            :browser/listen-post-message [::handle-message]}
           {:dispatch-n [[::load-questionnaires]
                         [::get-portal-token code]
                         [:toolkit.modal/show-modal :form-import]]
            :browser/listen-post-message [::handle-message]})
       (= :params phase)
       {:dispatch [::load-questionnaires]}

       (= :deinit phase)
       {:db (dissoc db
                    ::db)}))))
